import {storeSet} from "@/mixins/Auth.js";

export default [
    { // 메인
        path: '/',
        component: () => import("../views/prize/Prize.vue"),
        name: "EventHome",
        beforeEnter: storeSet,
        meta: {
            name: "EventHome", title: "코인몰", main: '코인존', sideHidden: true,
            mainClass: 'coin',
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
        // redirect: '/mission'
        redirect: '/ddoba'
    },
    // { // 메인
    //     path: '/coin',
    //     component: () => import("../views/prize/Prize.vue"),
    //     name: "PrizeMain",
    //     beforeEnter: storeSet,
    //     meta: {
    //         name: "PrizeMain", title: "코인몰", main: '선물함', sideHidden: true,
    //         mainClass: 'coin',
    //         authRequired: true,
    //         storeRequired: true,
    //         storeConfig: {userInfo: true},
    //     },
    // },
    { // ㅇㅗㄴ보드
        path: '/onboard',
        component: () => import('../views/auth/Onboard.vue'),
        name: 'Onboard',
        meta: {background: true,}
    },
    { // 로그인
        path: '/login',
        component: () => import('../views/auth/Login.vue'),
        name: 'Login',
        meta: {background: true,}
    },
    {  // 회원가입
        path: '/auth/register',
        component: () => import("../views/auth/Register.vue"),
        name: "Register",
        meta: {name: "Register", title: "회원가입", background: true,},
    },

    { // 회원가입 타입 선택
        path: '/auth/certified',
        component: () => import('../views/auth/AuthCertified.vue'),
        name: 'AuthCertified',
        meta: {background: true,}
    },

    {
        path: "/auth/certified/result",
        beforeEnter: storeSet,
        component: () => import("../views/auth/RegisterNiceResult.vue"),
        name: "RegisterNiceResult",
        meta: {name: "RegisterNiceResult", title: ""},
    },


    {  // 카카오 로그인 콜백(간편가입 동의창 인가코드 수신)
        path: '/auth/kakao/callback',
        component: () => import("../views/auth/KakaoCallback.vue"),
        name: "KakaoCallback",
        meta: {name: "KakaoCallback", title: "로그인", background: true,},
    },

    {  // 회원가입 - 마케팅 목적 개인정보 수집·이용 동의 안내(정적, 카카오 간편가입 약관 URL로도 사용)
        path: '/auth/register/terms/marketing',
        component: () => import("../views/auth/RegisterMarketingTerms.vue"),
        name: "RegisterMarketingTerms",
        meta: {name: "RegisterMarketingTerms", title: "회원가입", background: true,},
    },

    {  // 회원가입
        path: '/auth/register/terms/:key',
        component: () => import("../views/auth/RegisterTerms.vue"),
        name: "RegisterTerms",
        meta: {name: "RegisterTerms", title: "회원가입", background: true,},
    },

    {  // 회원가입완료
        path: '/auth/register/result',
        component: () => import("../views/auth/RegisterResult.vue"),
        name: "RegisterResult",
        meta: {name: "RegisterResult", title: "회원가입", background: true,},
    },


    {  // 회원가입
        path: '/auth/findid',
        component: () => import("../views/auth/FindId.vue"),
        name: "FindId",
        meta: {name: "FindId", title: "아이디찾기", background: true,},
    },
    {  // 회원가입
        path: '/auth/findpass',
        component: () => import("../views/auth/FindPass.vue"),
        name: "FindPass",
        meta: {name: "FindPass", title: "비밀번호찾기", background: true,},
    },

    {  // 회원가입
        path: '/auth/social/register',
        component: () => import("../views/auth/RegisterSocial.vue"),
        name: "RegisterSocial",
        meta: {name: "RegisterSocial", title: "회원가입", background: true,},
    },

    // 선물함
    {
        path: '/gift/coin',
        beforeEnter: storeSet,
        component: () => import("../views/gift/Coin.vue"),
        name: "GiftCoin",
        meta: {
            name: "GiftCoin", title: "코인몰", main: '선물함', mainClass:'gift', sideHidden: true,
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },

    //구독
    {
        path: '/subscript',
        beforeEnter: storeSet,
        component: () => import("../views/subscript/Subscript.vue"),
        name: "Subscript",
        meta: {
            name: "Subscript", title: "라이브 구독", main: '라이브 구독', sideHidden: true,
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
        children: [
            {
                path: '/subscript/purchase/:idx',
                component: () => import("../views/subscript/Purchase.vue"),
                name: "Purchase",
                meta: {
                    name: "Purchase", title: "라이브 구독", main: '라이브 구독', sideHidden: true,
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true},
                },
            },

            {
                path: '/subscript/record/:idx',
                component: () => import("../views/subscript/SubscriptRecord.vue"),
                name: "SubscriptRecord",
                meta: {
                    name: "SubscriptRecord", title: "라이브 구독", main: '라이브 구독', sideHidden: true,
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true},
                },
            },
            {
                path: '/subscript/refund/:idx',
                component: () => import("../views/subscript/RefundComplete.vue"),
                name: "RefundComplete",
                meta: {
                    name: "RefundComplete", title: "라이브 구독", main: '라이브 구독', sideHidden: true,
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true},
                },
            },

            {
                path: '/subscript/purchase/:idx/complete',
                component: () => import("../views/subscript/PurchaseComplete.vue"),
                name: "PurchaseComplete",
                meta: {
                    name: "PurchaseComplete", title: "라이브 구독", main: '라이브 구독', sideHidden: true,
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true},
                },
            },
        ],
    },

    {
        path: '/partner',
        component: () => import("../views/RouteView.vue"),
        name: "Partner",
        beforeEnter: storeSet,
        meta: {
            name: "Partner",
            title: "이웃 파트너 정보",
            main: '이웃 파트너',
            mainClass: 'partner',
            sideHidden: false,
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
        children: [
            {
                path: '',
                component: () => import("../views/partner/Partner.vue"),
                name: "Partner",
                beforeEnter: storeSet,
                meta: {
                    name: "Partner",
                    title: "이웃 파트너 정보",
                    main: '이웃 파트너',
                    mainClass: 'partner',
                    sideHidden: false,
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true},
                },
            },
            {
                path: '/partner/join/:type',
                beforeEnter: storeSet,
                component: () => import("../views/partner/PartnerJoin.vue"),
                name: "PartnerJoin",
                meta: {
                    name: "PartnerJoin",
                    title: "이웃 파트너 가입",
                    main: '이웃 파트너',
                    mainClass: 'partner',
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true},
                },
            },
            {
                path: '/partner/change/:type',
                component: () => import("../views/partner/PartnerChange.vue"),
                name: "PartnerChange",
                meta: {
                    name: "PartnerChange",
                    title: "이웃 파트너 정보",
                    main: '이웃 파트너',
                    mainClass: 'partner',
                    sideHidden: true,
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true},
                },
            },

            {
                path: '/partner/expire/:type',
                component: () => import("../views/partner/PartnerExpire.vue"),
                name: "PartnerExpire",
                meta: {
                    name: "PartnerExpire",
                    title: "이웃 파트너 해지",
                    main: '이웃 파트너',
                    mainClass: 'partner',
                    sideHidden: true,
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true},
                },
            },
            {
                path: '/partner/register',
                component: () => import("../views/partner/PartnerRegister.vue"),
                name: "PartnerRegister",
                meta: {
                    name: "PartnerRegister",
                    title: "이웃 파트너 가입",
                    main: '이웃 파트너',
                    mainClass: 'partner',
                    sideHidden: true,
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true},
                },
            },
        ],
    },

    {
        path: '/partner/join/complete',
        beforeEnter: storeSet,
        component: () => import("../views/partner/PartnerJoinComplete.vue"),
        name: "PartnerJoinComplete",
        meta: {
            name: "PartnerJoinComplete",
            title: "이웃 파트너 가입 완료",
            main: '이웃 파트너',
            mainClass: 'partner',
            sideHidden: true,
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },

    {
        path: '/mypage/video/publishing',
        component: () => import("../views/media/MediaPublishing.vue"),
        beforeEnter: storeSet,
        name: "MediaPublishing",
        meta: {
            name: "PartnerContentVideo",
            title: "영상 콘텐츠 관리",
            main: '이웃 파트너',
            mainClass: 'partnerContent',
            sideHidden: false,
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },
    {
        path: '/mypage/video/pending',
        component: () => import("../views/media/MediaPending.vue"),
        beforeEnter: storeSet,
        name: "MediaPending",
        meta: {
            name: "PartnerContentVideo",
            title: "영상 콘텐츠 관리",
            main: '이웃 파트너',
            mainClass: 'partnerContent',
            sideHidden: true,
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },

    {
        path: '/mypage/video/create/:type',
        component: () => import("../views/media/MediaCreate.vue"),
        name: "MediaCreate",
        beforeEnter: storeSet,
        meta: {
            name: "MediaCreate",
            title: "영상 등록",
            main: '영상 등록',
            sideHidden: true,
            mainClass: 'partnerContent',
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
        // redirect: returnRedirectPath,
    },
    {
        path: '/mypage/video/update/:idx/:type',
        component: () => import("../views/media/MediaUpdate.vue"),
        name: "MediaUpdate",
        beforeEnter: storeSet,
        meta: {
            name: "MediaUpdate",
            title: "영상 수정",
            main: '영상 수정',
            sideHidden: true,
            mainClass: 'partnerContent',
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },
    {
        path: '/mypage/video/:idx',
        component: () => import("../views/media/MediaDetail.vue"),
        name: "MediaDetail",
        beforeEnter: storeSet,
        meta: {
            name: "MediaDetail",
            title: "영상 상세",
            main: '영상 상세',
            sideHidden: true,
            mainClass: 'partnerContent',
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },
    {
        path: '/mypage/video/shorts/:idx',
        component: () => import("../views/media/MediaShortsDetail.vue"),
        name: "MediaDetailShorts",
        beforeEnter: storeSet,
        meta: {
            name: "MediaDetailShorts",
            title: "영상 상세",
            main: '영상 상세',
            sideHidden: true,
            mainClass: 'partnerContent',
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },


    {
        path: '/advertise',
        beforeEnter: storeSet,
        component: () => import("../views/ad/AdList.vue"),
        name: "AdList",
        meta: {
            name: "AdList",
            title: "광고 콘텐츠 관리",
            main: '이웃 파트너',
            mainClass: 'partnerAd',
            sideHidden: false,
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },
    {
        path: '/advertise/:idx',
        beforeEnter: storeSet,
        component: () => import("../views/ad/AdDetail.vue"),
        name: "AdDetail",
        meta: {
            name: "AdDetail",
            title: "광고 상세",
            main: '이웃 파트너',
            mainClass: 'partnerAd',
            sideHidden: true,
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },
    {
        path: '/advertise/create',
        beforeEnter: storeSet,
        component: () => import("../views/ad/AdCreateSelectItem.vue"),
        name: "AdCreateSelectItem",
        meta: {
            name: "AdCreateSelectItem",
            title: "광고 생성",
            main: '이웃 파트너',
            mainClass: 'partnerAd',
            sideHidden: true,
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
        children: [
            {
                path: ':type',
                component: () => import("../views/ad/AdCreateSelectType.vue"),
                beforeEnter: storeSet,
                name: "AdCreateSelectType",
                meta: {
                    name: "AdCreateSelectType",
                    title: "광고 생성",
                    main: '이웃 파트너',
                    mainClass: 'partnerAd',
                    sideHidden: true,
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true},
                },
            },
        ]
    },
    {
        path: '/advertise/create/:type/:idx',
        component: () => import("../views/ad/AdCreate.vue"),
        beforeEnter: storeSet,
        name: "AdCreate",
        meta: {
            name: "AdCreate",
            title: "광고 생성",
            main: '이웃 파트너',
            mainClass: 'partnerAd',
            sideHidden: true,
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },
    {
        path: '/advertise/:idx/:type/update',
        component: () => import("../views/ad/AdUpdate.vue"),
        beforeEnter: storeSet,
        name: "AdUpdate",
        meta: {
            name: "AdUpdate",
            title: "광고 생성",
            main: '이웃 파트너',
            mainClass: 'partnerAd',
            sideHidden: true,
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },
    {
        path: '/advertise/:idx/pay',
        component: () => import("../views/ad/AdPay.vue"),
        beforeEnter: storeSet,
        name: "AdPay",
        meta: {
            name: "PartnerContentAdvertisePay",
            title: "광고 콘텐츠 관리",
            main: '이웃 파트너',
            mainClass: 'partnerAd',
            sideHidden: true,
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },
    {
        path: '/advertise/:idx/pay/success',
        component: () => import("../views/ad/AdPaySuccess.vue"),
        beforeEnter: storeSet,
        name: "PartnerContentAdvertisePaySuccess",
        meta: {
            name: "PartnerContentAdvertisePaySuccess",
            title: "광고 콘텐츠 관리",
            main: '이웃 파트너',
            mainClass: 'partnerAd',
            sideHidden: true,
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },


    //쇼핑 콘텐츠 관리
    // {
    //     path: '/shopping',
    //     beforeEnter: storeSet,
    //     component: () => import("../views/shopping/Shopping.vue"),
    //     name: "Shopping",
    //     meta: {
    //         name: "Shopping",
    //         title: "쇼핑 콘텐츠 관리",
    //         main: '이웃 파트너',
    //         mainClass: 'partnerShopping',
    //         sideHidden: false,
    //         authRequired: true,
    //         storeRequired: true,
    //         storeConfig: {userInfo: true},
    //     },
    //     children: [
    //         {
    //             path: 'create',
    //             beforeEnter: storeSet,
    //             component: () => import("../views/shopping/ShoppingCreate.vue"),
    //             name: "ShoppingCreate",
    //             meta: {
    //                 name: "ShoppingCreate",
    //                 title: "쇼핑 콘텐츠 등록",
    //                 main: '이웃 파트너',
    //                 mainClass: 'partnerShopping',
    //                 sideHidden: true,
    //                 authRequired: true,
    //                 storeRequired: true,
    //                 storeConfig: {userInfo: true},
    //             }
    //         },
    //         {
    //             path: ':idx',
    //             beforeEnter: storeSet,
    //             component: () => import("../views/shopping/ShoppingDetail.vue"),
    //             name: "ShoppingDetail",
    //             meta: {
    //                 name: "ShoppingDetail",
    //                 title: "쇼핑 콘텐츠 관리 상세",
    //                 main: '이웃 파트너',
    //                 mainClass: 'partnerShopping',
    //                 sideHidden: true,
    //                 authRequired: true,
    //                 storeRequired: true,
    //                 storeConfig: {userInfo: true},
    //             },
    //         },
    //         {
    //             path: ':idx/update',
    //             beforeEnter: storeSet,
    //             component: () => import("../views/shopping/ShoppingUpdate.vue"),
    //             name: "ShoppingUpdate",
    //             meta: {
    //                 name: "ShoppingUpdate",
    //                 title: "쇼핑 콘텐츠 관리 수정",
    //                 main: '이웃 파트너',
    //                 mainClass: 'partnerShopping',
    //                 sideHidden: true,
    //                 authRequired: true,
    //                 storeRequired: true,
    //                 storeConfig: {userInfo: true},
    //             },
    //         },
    //     ],
    // },

    // TODOD 20260407 쇼핑 주석처리
    // {
    //     path: '/shopping/:idx/purchase',
    //     beforeEnter: storeSet,
    //     component: () => import("../views/shopping/ShoppingPurchase.vue"),
    //     name: "ShoppingPurchase",
    //     meta: {
    //         name: "ShoppingPurchase",
    //         title: "쇼핑 상품 구매",
    //         main: '쇼핑 콘텐츠',
    //         mainClass: 'ShoppingPurchase',
    //         sideHidden: true,
    //         authRequired: true,
    //         storeRequired: true,
    //         storeConfig: {userInfo: true},
    //     },
    // },
    // {
    //     path: '/shopping/:idx/purchase/detail',
    //     beforeEnter: storeSet,
    //     component: () => import("../views/shopping/ShoppingPurchaseDetail.vue"),
    //     name: "ShoppingPurchaseDetail",
    //     meta: {
    //         name: "ShoppingPurchaseDetail",
    //         title: "쇼핑 상품 구매",
    //         main: '쇼핑 콘텐츠',
    //         mainClass: 'ShoppingPurchaseDetail',
    //         sideHidden: true,
    //         authRequired: true,
    //         storeRequired: true,
    //         storeConfig: {userInfo: true},
    //     },
    // },
    {
        path: '/shopping/purchase/complete/:idx',
        beforeEnter: storeSet,
        component: () => import("../views/shopping/ShoppingComplete.vue"),
        name: "ShoppingComplete",
        meta: {
            name: "ShoppingComplete",
            title: "결제 완료",
            main: '이웃 파트너',
            mainClass: 'partnerShopping',
            sideHidden: true,
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },
    //쇼핑 콘텐츠 관리 상세


    // 공지
    {
        path: '/mypage/notice',
        beforeEnter: storeSet,
        component: () => import("../views/notice/Notice.vue"),
        name: "Notice",
        meta: {
            name: "Notice", title: "공지사항", main: '고객센터', mainClass: 'notice', sideHidden: false,
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
        children: [
            {
                path: '/mypage/notice/:idx',
                component: () => import("../views/notice/NoticeDetail.vue"),
                name: "NoticeDetail",
                meta: {
                    name: "NoticeDetail",
                    title: "공지사항",
                    main: '고객센터',
                    sideHidden: true,
                    mainClass: 'notice',
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true},
                },
            },


        ],
    },


    // 약관
    {
        path: '/config',
        beforeEnter: storeSet,
        component: () => import("../views/terms/Config.vue"),
        name: "Config",
        meta: {
            name: "Config", title: "약관", main: '고객센터', mainClass: 'cofig', authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true}, sideHidden: false,
        },
    },
    // faq
    {
        path: '/faq',
        beforeEnter: storeSet,
        component: () => import("../views/faq/FaqList.vue"),
        name: "FaqList",
        meta: {
            name: "FaqList",
            title: "자주 묻는 질문",
            main: '고객센터',
            mainClass: 'faq',
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
            sideHidden: false,
        },

    },

    // 1:1문의
    {
        path: '/mypage/qna',
        beforeEnter: storeSet,
        component: () => import("../views/RouteView.vue"),
        name: "Qna",
        meta: {
            name: "Qna", title: "1:1 문의", main: '고객센터', mainClass: 'qna', sideHidden: false,
            storeRequired: true,
            authRequired: true,
            storeConfig: {userInfo: true},
        },
        children: [
            {
                path: '',
                beforeEnter: storeSet,
                component: () => import("../views/qna/Qna.vue"),
                name: "Qna",
                meta: {
                    name: "Qna", title: "1:1 문의", main: '고객센터', mainClass: 'qna', sideHidden: false,
                    storeRequired: true,
                    authRequired: true,
                    storeConfig: {userInfo: true},
                },
            },
            {
                path: 'create',
                component: () => import("../views/qna/QnaCreate.vue"),
                name: "QnaCreate",
                meta: {
                    name: "QnaCreate",
                    title: "1:1 문의 등록",
                    main: '고객센터',
                    sideHidden: true,
                    mainClass: 'qna',
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true},
                },
                // redirect: returnRedirectPath,
            },
            {
                path: ':idx',
                component: () => import("../views/qna/QnaDetail.vue"),
                name: "QnaDetail",
                meta: {
                    name: "QnaDetail",
                    title: "1:1 문의 상세",
                    main: '고객센터',
                    sideHidden: true,
                    mainClass: 'qna',
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true},
                },
                // redirect: returnRedirectPath,
            },
            {
                path: 'update/:idx',
                component: () => import("../views/qna/QnaUpdate.vue"),
                name: "QnaUpdate",
                meta: {
                    name: "QnaUpdate",
                    title: "1:1 문의 수정",
                    main: '고객센터',
                    sideHidden: true,
                    mainClass: 'qna',
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true},
                },
            },

        ],
    },


    {
        path: "/certified/first/result",
        beforeEnter: storeSet,
        component: () => import("../views/auth/AuthNiceResult.vue"),
        name: "AuthNiceFirstResult",
        meta: {name: "AuthNiceFirstResult", title: ""},
    },
    {
        path: "/certified/hp/result",
        beforeEnter: storeSet,
        component: () => import("../views/auth/AuthNiceResult.vue"),
        name: "AuthNiceResultHp",
        meta: {name: "AuthNiceResultHp", title: ""},
    },
    {  // 약관
        path: '/terms/:idx',
        beforeEnter: storeSet,
        component: () => import("../views/terms/Terms.vue"),
        name: "Terms",
        meta: {
            name: "Terms", title: "약관",
        },
    },
    {
        path: "/alarm",
        beforeEnter: storeSet,
        component: () => import('../views/alarm/Alarm.vue'),
        name: "alarm",
        meta: {
            name: "alarm", title: "알림",
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },

    {
        path: '/payment/product',
        beforeEnter: storeSet,
        component: () => import("../views/mypage/ProductManage.vue"),
        name: "ProductManage",
        meta: {
            name: "ProductManage", title: "결제 내역",/*"나의 상품관리*/ main: '마이페이지', mainClass: 'product', sideHidden: false,
            storeRequired: true,
            authRequired: true,
            storeConfig: {userInfo: true},
        },
    },


    {
        path: '/mypage/history/:idx',
        beforeEnter: storeSet,
        component: () => import("../views/mypage/HistoryDetail.vue"),
        name: "HistoryDetail",
        meta: {
            name: "HistoryDetail", title: "결제 내역 상세", main: '마이페이지', mainClass: 'product', sideHidden: true,
            storeRequired: true,
            authRequired: true,
            storeConfig: {userInfo: true},
        },
    },

    //구매 내역
    {
        path: '/mypage/purchase/history',
        component: () => import("../views/mypage/ShopPurchaseHistory.vue"),
        beforeEnter: storeSet,
        name: "ShopPurchaseHistory",
        meta: {
            name: "ShopPurchaseHistory", title: "쇼핑 구매 내역", main: '마이페이지', mainClass: 'shopHistory', sideHidden: false,
            storeRequired: true,
            authRequired: true,
            storeConfig: {userInfo: true},
        },
    },

    {
        path: '/mypage/purchase/history/refund',
        component: () => import("../views/mypage/ShopRefundHistory.vue"),
        beforeEnter: storeSet,
        name: "ShopRefundHistory",
        meta: {
            name: "ShopRefundHistory", title: "쇼핑 구매 내역", main: '마이페이지',
            mainClass: 'shopHistory', sideHidden: true,
            storeRequired: true,
            authRequired: true,
            storeConfig: {userInfo: true},
        },
    },
    //구매 내역 상세
    {
        path: '/mypage/purchase/history/:idx',
        component: () => import("../views/mypage/ShopPurchaseHistoryDetail.vue"),
        name: "ShopPurchaseDetailHistory",
        title: "쇼핑 구매 내역 상세",
        meta: {
            mainClass: 'shopHistory',
            sideHidden: true,
            main: '마이페이지',
            storeRequired: true,
            authRequired: true,
            storeConfig: {userInfo: true},
        },
    },
    {
        path: '/mypage/purchase/request/:type/:idx',
        component: () => import("../views/mypage/ShopPurchaseRequest.vue"),
        name: "ShopPurchaseRequest",
        title: "레인보우 쇼핑 교환/반품 요청",
        meta: {
            mainClass: 'ShopPurchaseRequest',
            sideHidden: true,
            main: '마이페이지',
            storeRequired: true,
            authRequired: true,
            storeConfig: {userInfo: true},
        },
    },
    {
        path: '/mypage/purchase/history/refund/:idx',
        component: () => import("../views/mypage/ShopPurchaseHistoryRefundDetail.vue"),
        beforeEnter: storeSet,
        name: "ShopPurchaseHistoryRefundDetail",
        meta: {
            name: "ShopPurchaseHistoryRefundDetail",
            title: "쇼핑 반품 내역",
            main: '마이페이지',
            mainClass: 'ShopPurchaseDetailHistory',
            sideHidden: true,
            storeRequired: true,
            authRequired: true,
            storeConfig: {userInfo: true},
        },
    },
    {
        path: '/mypage/purchase/history/trade/:idx',
        component: () => import("../views/mypage/ShopPurchaseHistoryTradeDetail.vue"),
        beforeEnter: storeSet,
        name: "ShopPurchaseHistoryTradeDetail",
        meta: {
            name: "ShopPurchaseHistoryTradeDetail",
            title: "쇼핑 교환 내역",
            main: '마이페이지',
            mainClass: 'ShopPurchaseDetailHistory',
            sideHidden: true,
            storeRequired: true,
            authRequired: true,
            storeConfig: {userInfo: true},
        },
    },

/*    {
        path: '/mypage/affiliate',
        beforeEnter: storeSet,
        component: () => import("../views/mypage/Affiliate.vue"),
        name: "Affiliate",
        meta: {
            name: "Affiliate", title: "제휴상품 교환내역", main: '마이페이지', mainClass: 'affiliate', sideHidden: false,
            storeRequired: true,
            authRequired: true,
            storeConfig: {userInfo: true},
        },
        children: [],
    },*/

    // 코인 내역
/*    {
        path: '/mypage/coin',
        beforeEnter: storeSet,
        component: () => import("../views/mypage/Coin.vue"),
        name: "Coin",
        meta: {
            name: "Coin", title: "코인 내역", main: '마이페이지', mainClass: 'myCoin', sideHidden: false,
            storeRequired: true,
            authRequired: true,
            storeConfig: {userInfo: true},
        },
        children: [
            {
                path: 'exchange',
                component: () => import("../views/mypage/CoinExchange.vue"),
                name: "Coin",
                meta: {
                    name: "CoinExchange", title: "코인 교환", main: '마이페이지', mainClass: 'myCoin',
                    storeRequired: true,
                    authRequired: true,
                    storeConfig: {userInfo: true},
                },
            },
        ],
    },*/

    // 골드 코인 내역
    {
        path: '/mypage/gold-coin',
        beforeEnter: storeSet,
        component: () => import("../views/mypage/GoldCoin.vue"),
        name: "GoldCoin",
        meta: {
            name: "GoldCoin",
            title: "골드 코인 내역",
            main: '마이페이지',
            mainClass: 'goldCoin',
            sideHidden: false,
            storeRequired: true,
            authRequired: true,
            storeConfig: {userInfo: true},
        },
    },

    //포인트 내역
/*    {
        path: '/mypage/point',
        beforeEnter: storeSet,
        component: () => import("../views/mypage/Point.vue"),
        name: "MypagePoint",
        meta: {
            name: "MypagePoint", title: "포인트 내역", main: '마이페이지', mainClass: 'myPoint', sideHidden: false,
            storeRequired: true,
            authRequired: true,
            storeConfig: {userInfo: true},
        },
        children: [],
    },*/
    {
        path: '/coupon',
        component: () => import("../views/mypage/Coupon.vue"),
        name: 'Coupon',
        beforeEnter: storeSet,
        meta: {
            title: "쿠폰함", main: '마이페이지', sideHidden: false, mainClass: 'coupon',
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        }
    },
    //내 정보 변경
    {
        path: '/mypage/info',
        beforeEnter: storeSet,
        component: () => import("../views/mypage/Mypage.vue"),
        name: "MypageInfo",
        meta: {
            name: "MypageInfo", title: "내 정보 관리", main: '마이페이지', mainClass: 'myInfo', sideHidden: false,
            storeRequired: true,
            authRequired: true,
            storeConfig: {userInfo: true},
        },
        children: [],
    },
    {
        path: '/mypage/recommender',
        beforeEnter: storeSet,
        component: () => import("../views/mypage/Recommender.vue"),
        name: "Recommender",
        meta: {
            name: "Recommender", title: "내 정보 관리", main: '마이페이지', mainClass: 'myInfo', sideHidden: true,
            storeRequired: true,
            authRequired: true,
            storeConfig: {userInfo: true},
        },
        children: [],
    },
    {
        path: '/promotion',
        beforeEnter: storeSet,
        component: () => import("../views/mypage/Promotion.vue"),
        name: "Promotion",
        meta: {
            name: "Promotion", title: "프로모션", main: '마이페이지', mainClass: 'promotion', sideHidden: false,
            storeRequired: true,
            authRequired: true,
            storeConfig: {userInfo: true},
        },
        children: [],
    },
    //알림 설정
    {
        path: '/mypage/alarm',
        beforeEnter: storeSet,
        component: () => import("../views/mypage/MypageAlarm.vue"),
        name: "MypageAlarm",
        meta: {
            name: "MypageAlarm", title: "알림 설정", main: '마이페이지', mainClass: 'mypage', sideHidden: false,
            storeRequired: true,
            authRequired: true,
            storeConfig: {userInfo: true},
        },
    },

    //회원 탈퇴
    {
        path: '/mypage/quit',
        beforeEnter: storeSet,
        component: () => import("../views/mypage/MypageQuit.vue"),
        name: "Quit",
        meta: {
            name: "Quit", title: "회원 탈퇴", main: '마이페이지', mainClass: 'leave', sideHidden: false,
            storeRequired: true,
            authRequired: true,
            storeConfig: {userInfo: true},
        },
    },

    /* {
         path: '/',
         name: 'sample',
         meta: {title: "통계", main: '이웃 파트너', sideHidden: false, mainClass: 'statistics'}
     },*/


    {
        path: '/pay/result/success',
        component: () => import('../views/pay/PaySuccess.vue'),
        beforeEnter: storeSet,
        name: 'PaySuccess',
        meta: {
            name: "MediaUpdate",
            title: "결제",
            main: '결제',
            sideHidden: true,
            mainClass: '',
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },

    {
        path: '/pay/result/fail',
        component: () => import('../views/pay/PayFail.vue'),
        beforeEnter: storeSet,
        name: 'PayFail',
        meta: {
            name: "PayFail",
            title: "결제",
            main: '결제',
            sideHidden: true,
            mainClass: '',
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },


    // 포인트 > 럭키 룰렛
    {
        path: "/roulette",
        component: () => import("../views/roulette/Roulette.vue"),
        name: "Roulette",
        meta: {
            name: "Roulette",
            title: "룰렛",
            main: '룰렛',
            sideHidden: true,
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },

    {
        path: '/mission',
        beforeEnter: storeSet,
        component: () => import("../views/mission/Mission.vue"),
        name: "Mission",
        meta: {
            name: "Mission",
            title: "이벤트",
            main: '코인존',
            mainClass: 'mission',
            sideHidden: false,
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },

    {
        path: '/ddoba',
        beforeEnter: storeSet,
        component: () => import("../views/gift/Ddoba.vue"),
        name: "Ddoba",
        meta: {
            name: "Ddoba",
            title: "또바몰",
            main: '선물함',
            mainClass: 'ddoba',
            sideHidden: false,
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
        children: [
            {
                path: '/ddoba/:idx',
                beforeEnter: storeSet,
                component: () => import("../views/gift/DdobaDetail.vue"),
                name: "DdobaDetail",
                meta: {
                    name: "DdobaDetail",
                    title: "또바몰 상세",
                    main: '선물함',
                    mainClass: 'ddoba',
                    sideHidden: true,
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true},
                },
            },
        ]
    },
    {
        path: '/event',
        beforeEnter: storeSet,
        component: () => import("../views/gift/Event.vue"),
        name: "Event",
        meta: {
            name: "Event",
            title: "이벤트",
            main: '선물함',
            mainClass: 'event',
            sideHidden: false,
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true},
        },
    },


    

    {
        path: '/unity/:type',
        component: () => import('../views/auth/UnityLogin.vue'),
        name: 'Unity',
        meta: {background: true,}
    },


]
